export function getCanonicalRiskIdentity(row) {
    const value = row?.cognive_id;
    if (value == null) return null;
    const normalized = String(value).trim();
    return normalized || null;
}

export function indexRiskRowsByCanonicalIdentity(rows = []) {
    const byIdentity = new Map();
    let unjoinableCount = 0;
    (Array.isArray(rows) ? rows : []).forEach((row) => {
        const identity = getCanonicalRiskIdentity(row);
        if (!identity) {
            unjoinableCount += 1;
        } else if (!byIdentity.has(identity)) {
            byIdentity.set(identity, row);
        }
    });
    return { byIdentity, unjoinableCount };
}

export function buildCanonicalRiskComparisonRows(actualRows = [], optimizedRows = []) {
    const actual = Array.isArray(actualRows) ? actualRows : [];
    const optimized = Array.isArray(optimizedRows) ? optimizedRows : [];
    const { byIdentity: optimizedByIdentity, unjoinableCount: optimizedUnjoinableCount } = (
        indexRiskRowsByCanonicalIdentity(optimized)
    );
    const includedIdentities = new Set();
    let actualUnjoinableCount = 0;

    const rows = actual.map((row, index) => {
        const identity = getCanonicalRiskIdentity(row);
        if (identity) {
            includedIdentities.add(identity);
        } else {
            actualUnjoinableCount += 1;
        }
        return {
            ...row,
            _riskOverviewRowKey: identity ?? `actual-unjoinable-${index}`,
            _identityJoinStatus: identity ? 'canonical' : 'unjoinable',
        };
    });

    optimized.forEach((row, index) => {
        const identity = getCanonicalRiskIdentity(row);
        if (identity && includedIdentities.has(identity)) return;
        if (identity) includedIdentities.add(identity);
        rows.push({
            ...row,
            _isOptimizedOnly: true,
            _riskOverviewRowKey: identity ?? `optimized-unjoinable-${index}`,
            _identityJoinStatus: identity ? 'canonical' : 'unjoinable',
        });
    });

    return {
        rows,
        optimizedByIdentity,
        diagnostics: {
            actualUnjoinableCount,
            optimizedUnjoinableCount,
        },
    };
}
